export default function Footer() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="relative px-3 md:px-4 pb-3 md:pb-4 pt-6 md:pt-10 bg-background-100 z-10">
      {/* Organic top divider */}
      <div className="absolute top-0 left-0 right-0 h-16 md:h-20 overflow-hidden pointer-events-none">
        <svg viewBox="0 0 1440 80" preserveAspectRatio="none" className="absolute bottom-0 w-full h-full">
          <path
            d="M0,40 C240,15 480,65 720,40 C960,15 1200,65 1440,40 L1440,80 L0,80 Z"
            fill="oklch(var(--foreground-900))"
          />
        </svg>
      </div>

      <div className="rounded-2xl bg-foreground-900 text-background-100 overflow-hidden mt-10 md:mt-14 relative">
        <div className="relative px-5 sm:px-6 md:px-12 pt-10 sm:pt-12 md:pt-16 pb-8 md:pb-12 grid grid-cols-1 md:grid-cols-12 gap-8 sm:gap-10 md:gap-8">
          <div className="md:col-span-4">
            <div className="flex items-center gap-2.5 mb-6">
              <span className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-500 text-background-50">
                <i className="ri-restaurant-2-fill text-xl"></i>
              </span>
              <div className="flex flex-col leading-tight">
                <span className="text-lg font-heading font-bold text-background-50">Big Mania</span>
                <span className="text-[10px] uppercase tracking-[0.18em] text-background-300">Sanduíches Naturais</span>
              </div>
            </div>
            <p className="text-sm text-background-200 leading-relaxed max-w-xs">
              Fábrica de sanduíches naturais e alimentos congelados em Fortaleza desde 2005. Qualidade, sabor e confiança para varejo, atacado, empresas e eventos.
            </p>
            <div className="mt-6 flex items-center gap-3">
              <span className="relative w-2.5 h-2.5 rounded-full text-emerald-400 pulse-dot bg-emerald-400"></span>
              <span className="text-sm text-background-100">Aberto agora — Seg a Sex, 07h às 17h</span>
            </div>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-xs uppercase tracking-[0.2em] text-background-300 mb-5 font-medium">Navegue</h4>
            <ul className="space-y-3 text-sm">
              <li><a href="#hero" onClick={(e) => handleClick(e, "#hero")} className="hover:text-primary-400 transition-colors cursor-pointer border-reveal pb-0.5 inline-block">Início</a></li>
              <li><a href="#catalogo" onClick={(e) => handleClick(e, "#catalogo")} className="hover:text-primary-400 transition-colors cursor-pointer border-reveal pb-0.5 inline-block">Produtos</a></li>
              <li><a href="#eventos" onClick={(e) => handleClick(e, "#eventos")} className="hover:text-primary-400 transition-colors cursor-pointer border-reveal pb-0.5 inline-block">Eventos</a></li>
              <li><a href="#onde-encontrar" onClick={(e) => handleClick(e, "#onde-encontrar")} className="hover:text-primary-400 transition-colors cursor-pointer border-reveal pb-0.5 inline-block">Onde Encontrar</a></li>
              <li><a href="#contato" onClick={(e) => handleClick(e, "#contato")} className="hover:text-primary-400 transition-colors cursor-pointer border-reveal pb-0.5 inline-block">Contato</a></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-xs uppercase tracking-[0.2em] text-background-300 mb-5 font-medium">Fale Conosco</h4>
            <ul className="space-y-3 text-sm">
              <li>
                <a href="tel:+558534942701" className="flex items-center gap-2 hover:text-primary-400 transition-colors cursor-pointer">
                  <i className="ri-phone-fill"></i> (85) 3494-2701
                </a>
              </li>
              <li>
                <a href="https://wa.me/558534942701" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-primary-400 transition-colors cursor-pointer">
                  <i className="ri-whatsapp-line"></i> WhatsApp
                </a>
              </li>
              <li>
                <a href="https://www.instagram.com/bigmaniasanduiches/" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-primary-400 transition-colors cursor-pointer">
                  <i className="ri-instagram-line"></i> @bigmaniasanduiches
                </a>
              </li>
              <li className="flex items-start gap-2 text-background-200">
                <i className="ri-map-pin-line mt-0.5 shrink-0"></i>
                <span>Rua Capitão Vasconcelos, 233 — Aerolândia, Fortaleza/CE</span>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-xs uppercase tracking-[0.2em] text-background-300 mb-5 font-medium">Faça seu Pedido</h4>
            <p className="text-sm text-background-200 mb-5">Praticidade e sabor na porta da sua empresa ou evento.</p>
            <a
              href="https://wa.me/558534942701"
              target="_blank"
              rel="noopener noreferrer"
              className="group inline-flex items-center gap-2 px-5 py-3 rounded-lg bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-400 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              Pedir pelo WhatsApp
              <i className="ri-arrow-right-up-line transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5"></i>
            </a>
            <div className="mt-6 flex items-center gap-4 text-xs text-background-300">
              <span className="inline-flex items-center gap-1.5"><i className="ri-shield-check-line"></i> Segurança Alimentar</span>
              <span className="inline-flex items-center gap-1.5"><i className="ri-award-line"></i> Desde 2005</span>
            </div>
          </div>
        </div>

        <div className="relative border-t border-background-50/10">
          <div className="relative px-5 sm:px-6 md:px-12 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-300 text-center sm:text-left">
            <p>© {new Date().getFullYear()} Big Mania Sanduíches Naturais · Fortaleza/CE</p>
            <div className="flex items-center gap-5">
              <span className="hover:text-primary-400 transition-colors cursor-pointer">Política de Privacidade</span>
              <span className="hover:text-primary-400 transition-colors cursor-pointer">Termos de Uso</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}